import styled from '@emotion/styled';
interface TabButtonProps {
	isActive?: boolean; // isActive를 선택적 prop으로 정의
}
export const MainWrapper = styled.main`
	padding-top: 0px;
	position: relative;

	.container {
		width: 100%;
		position: relative;
	}
`;

export const MainBanner = styled.article`
	padding: 0;
	min-height: 50rem;
	height: 88rem;
	color: #fff;
	position: relative;

	@media screen and (max-width: 900px) {
		max-height: 50rem;
	}

	.swiper {
		width: 100%;
		height: 100%;
	}

	.swiper-slide {
		width: 100% !important;
		height: 100% !important;
		position: relative;
	}

	.first {
		width: 100%;
		position: relative;
		height: 100%;
	}

	.first_background {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.textBoxWrapper {
		position: absolute;
		top: 36.7rem;
		width: 100%;
		z-index: 10;
		@media screen and (max-width: 900px) {
			top: 14.9rem;
		}
	}

	.textBox {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		max-width: 135rem;
		width: 100%;
		margin: 0 auto;
		padding: 0 2rem;

		.title {
			color: #fff;
			font-size: 6.4rem;
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
			line-height: 110%;
			letter-spacing: -0.6px;
			align-self: stretch;

			@media screen and (max-width: 900px) {
				font-size: 3.4rem;
			}
		}

		.description {
			font-size: 18px;
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 140%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.sizeMd};
			}
		}

		.pagination-container {
			margin-top: 2rem;
		}
	}
	.swiper-pagination_custom {
		position: absolute;
		bottom: 28%;
		left: 0;
		right: 0;
		display: flex;

		max-width: 135rem;
		width: 100%;
		margin: 0 auto;
		z-index: 10;
		@media screen and (max-width: 900px) {
			bottom: 25%;
		}
		@media screen and (max-width: 412px) {
			bottom: 10%;
		}
		@media screen and (max-width: 345px) {
			bottom: 2%;
		}
		.swiper-pagination {
			gap: 2.2rem;
			padding: 0 2rem;
			display: flex;
		}
	}

	/* 페이지네이션 점 스타일링 */
	.swiper-pagination-bullet {
		width: 12px;
		height: 12px;
		background: white;
		opacity: 0.7;
		display: inline-block;
		border-radius: 50%;
		transition: all 0.3s ease;
		border: 1px solid #adb5bd; /* 파란색 - 이미지와 일치하도록 조정 */
		margin: 0 !important;
	}
	.swiper-pagination-bullet-active {
		background: #003399; /* 파란색 - 이미지와 일치하도록 조정 */
		opacity: 1;
	}

	/* 네비게이션 화살표 스타일링 (옵션) */
	.swiper-button-next,
	.swiper-button-prev {
		display: none;
	}
`;
export const Description = styled.section`
	padding: 8rem 0;
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
	.main_description_title {
		color: #212529;
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 1.6rem;
		@media screen and (max-width: 900px) {
			text-align: left;
		}
		.description_title {
			font-size: ${(props) => props.theme.fontSize.size6xl};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: 130%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.size4xl};
			}
		}
		.description_sub_title {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 130%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 660px) {
				br {
					display: none;
				}
			}
		}
	}
`;

export const CardList = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);

	@media screen and (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 420px) {
		grid-template-columns: repeat(1, 1fr);
	}
	/* .border-bottom {
		border-bottom: 1px solid #e9ecef;
	}
	.border-left {
		border-left: 1px solid #e9ecef;
	}
	.border-right {
		border-right: 1px solid #e9ecef;
	}
	.dark {
		background-color: #f1f3f5;
	} */
`;

export const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	order: 2;
`;
export const CardTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};

	letter-spacing: -0.6px;
	display: flex;
	align-items: center;
`;

export const ImgBox = styled.div`
	display: flex;
	max-width: 8rem;
	img {
		width: 100%;
	}
`;
export const ImgBoxWrapper = styled.div`
	@media screen and (max-width: 900px) {
		display: flex;
		justify-content: flex-start;
	}
`;
export const CardSubTitle = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const Notice = styled.section`
	padding: 8rem 0;
	/* margin: 0 auto;
	max-width: 135rem;
	width: 100%; */
	background-color: #f1f3f5;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
	@media screen and (max-width: 900px) {
		padding: 6rem 2rem;
	}
	.content {
		padding: 2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
	}
`;

export const NoticeList = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 2rem 3.2rem;
	.last {
		border-bottom: none;
	}
`;
export const NoticeEmptyBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;
export const NoticeListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem 0;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 100%;
	border-bottom: 1px solid #e9ecef;
	cursor: pointer;
	.title {
		color: #212529;
	}
	.sub_title {
		color: #868e96;
	}
`;

export const Divider = styled.div`
	width: 1px;
	height: 29px;
	background-color: #dee2e6;
	margin: 0 1.6rem;
`;
export const EmptyEl = styled.div``;

export const NoticeContent = styled.div`
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const NoticeContentList = styled.div`
	display: flex;
	gap: 3.2rem;
	justify-content: space-between;
	width: 100%;
	@media screen and (max-width: 900px) {
		flex-direction: column;
	}
`;

export const CardImg = styled.div<{ bgImg: string }>`
	background-image: linear-gradient(0deg, rgba(0, 21, 52, 0.6) 0%, rgba(0, 21, 52, 0.6) 100%), url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-clip: content-box;
	background-origin: content-box;
	position: relative;
	display: flex;
	border-radius: 1.6rem;
	flex: 1;
	min-height: 41rem;
	max-height: 45rem;
	width: 100%;
	cursor: pointer;
	box-shadow:
		0px 0px 4px 0px rgba(0, 0, 0, 0.06),
		4px 8px 8px 0px rgba(0, 0, 0, 0.02),
		12px 8px 24px 0px rgba(0, 0, 0, 0.1);

	.title_box {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;
		position: absolute;
		top: 50%;
		left: 3rem;
		transform: translateY(-50%);
		@media screen and (max-width: 900px) {
			right: 3rem;
		}
		.title {
			color: #fff;
			font-size: 3.6rem;
			font-weight: 700;
			line-height: 120%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: 3.2rem;
			}
		}
		.sub_title {
			color: #fff;
			font-size: 1.8rem;
			font-weight: 400;
			line-height: 120%;
			letter-spacing: -0.6px;
		}
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 1.6rem;
	}
`;
export const NoticeButtonTab = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ButtonList = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const TabButton = styled.div<TabButtonProps>`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	background: none;
	color: ${(props) => (props.isActive ? '#212529' : '#adb5bd')};
	border: none;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;

export const NoticeTabList = styled.div`
	display: flex;
	gap: 3.2rem;
`;

export const Wrapper = styled.div`
	display: flex;
	width: 50%;
	justify-content: space-between;

	@media screen and (max-width: 900px) {
		width: 100%;
		gap: 2.4rem;
		flex-direction: column;
	}
`;

export const GotoButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.8rem;
	border: none;
	background: none;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #495057;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		justify-content: flex-end;
	}
`;

export const ContentCard = styled.div`
	border-radius: 1.6rem;
	background-color: #fff;
`;

export const Company = styled.div`
	padding: 8rem 0;
	max-width: 135rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	@media screen and (max-width: 1370px) {
		padding-left: 2rem;
	}
	.title {
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #212529;
	}
	.swiper {
		--swiper-space-between: 16px;
	}
	.swiper-wrapper {
	}
	.swiper-slide {
		width: unset;
		height: 14.7rem;
		/* height: 16.2rem; */
	}
	.swiper-button-prev {
		right: 4.6rem;
		top: unset;
		bottom: 0;
		left: unset;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 6.6rem;
		}
	}
	.swiper-button-next {
		right: 0rem;
		top: unset;
		bottom: 0;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 2rem;
		}
		/* width: 2.2rem; */
	}
	.swiper-button-prev::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
	.swiper-button-next::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
`;

export const CompanyCard = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 1.6rem;
	background-color: #f8f9fa;
	width: 21.2rem;
	height: 9.1rem;
	img {
		max-width: 14rem;
		width: 100%;
	}
`;
export const EmptyData = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;
